import { render } from "./RpmFileInput.vue?vue&type=template&id=0cbb8027"
import script from "./RpmFileInput.vue?vue&type=script&lang=js"
export * from "./RpmFileInput.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__